<app-page [page]="page"></app-page>

<div class="page-container">
  <div class="page-container-wrapper">
    <main class="page-container-main">
      <article app-news-entry *ngFor="let entry of newsItems" [entry]="entry"></article>
    </main>
  </div>
</div>
